import React from 'react'
import { Provider } from 'react-redux'
import { interfaceBase } from 'lib/styleguide/base.scss'
import { initStore } from '../redux/initStore'
import { Route } from 'react-router'
import { Overview } from '../Overview'
import { LoadableExperienceShow } from '../ExperienceShow'
import { RoutesPage } from '../RoutesPage'
import { GuidePage } from '../GuidePage'
import { PrintGuide } from '../PrintGuide'
import { Config } from '../ExperienceShow/Config'
import { Details } from '../Details'
import { Guests } from '../Guests'
import { Messages } from '../Messages'
import { SideNavLayout } from 'common/layouts/SideNavLayout'
import { StandardLayout } from 'common/layouts/StandardLayout'
import { DeleteExperienceDialog, DELETE_EXPERIENCE_DIALOG } from '../dialogs/DeleteExperienceDialog'
import { CopyExperienceDialog, COPY_EXPERIENCE_DIALOG } from '../dialogs/CopyExperienceDialog'
import { ExperiencesSideNav } from './ExperiencesSideNav'
import { Billing } from '../Billing'
import { ShortcutQR } from '../ShortcutQR'

export const getExperienceId = (props) => parseInt(props.params.experienceId, 10)

export const sharedDroppableStyle = isDraggingOver => (
  isDraggingOver
    ? {
      border: '2px dashed #6982FF',
      borderBottom: '0px',
      borderTopLeftRadius: '5px',
      borderTopRightRadius: '5px'
    }
    : null
)

export const sharedPlaceholderStyle = isDraggingOver => (
  isDraggingOver
    ? {
      border: '2px dashed #6982FF',
      borderTop: '0px',
      borderLeft: '0px',
      borderRight: '0px',
      borderBottomLeftRadius: '5px',
      borderBottomRightRadius: '5px'
    }
    : null
)

const store = initStore()

const DataLayer = ({ children }) => (
  <Provider store={store}>{children}</Provider>
)

class ExperiencesApp extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      dialog: null
    }
  }

  showDialog = (dialog) => {
    this.setState({ dialog })
  }
  hideDialog = () => {
    this.setState({ dialog: null })
  }

  render () {
    const { children } = this.props
    const { dialog } = this.state
    const experienceId = getExperienceId(this.props)

    return (
      <SideNavLayout
        nav={<ExperiencesSideNav experienceId={experienceId} showDialog={this.showDialog} />}
        greyBg>
        <div className={interfaceBase}>
          {children}
        </div>
        {dialog === DELETE_EXPERIENCE_DIALOG &&
          <DeleteExperienceDialog
            experienceId={experienceId}
            onRequestClose={this.hideDialog} />}
        {dialog === COPY_EXPERIENCE_DIALOG &&
          <CopyExperienceDialog
            experienceId={experienceId}
            onRequestClose={this.hideDialog} />}
      </SideNavLayout>
    )
  }
}

const PrintApp = ({ children }) => (
  <Provider store={store}>
    {children}
  </Provider>
)

export const routes = (
  <Route component={DataLayer}>
    <Route component={PrintApp}>
      <Route path=':experienceId/print_guide' component={PrintGuide} />
    </Route>
    <Route component={ExperiencesApp}>
      <Route path=':experienceId/details' component={Details} />
      <Route path=':experienceId/messages' component={Messages} />
      <Route path=':experienceId/routes' component={RoutesPage} />
      <Route path=':experienceId/guide' component={GuidePage} />
      <Route path=':experienceId/guests' component={Guests} />
      <Route path=':experienceId/edit' component={Overview} />
    </Route>
    <Route component={(props) => <StandardLayout {...props} greyBg />}>
      <Route path=':experienceId' component={LoadableExperienceShow} />
      <Route path=':experienceId/view_config' component={Config} />
      <Route path=':experienceId/billing' component={Billing} />
      <Route path=':experienceId/shortcut' component={ShortcutQR} />
    </Route>
  </Route>
)
